import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-impersonate',
  template: ``,
})
export class ImpersonateComponent implements OnInit, OnDestroy {
  constructor(public auth: AuthenticationService, private router: Router, private activatedRoute: ActivatedRoute) {
    //
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.queryParams.hasOwnProperty('token')) {
      const token = this.activatedRoute.snapshot.queryParams['token'];

      const parse = (_token: string) => {
        const base64Url = _token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
      };

      const data = parse(token);
      const credentials = {
        username: data.username || data.impersonator.email,
        accessToken: token,
        refreshToken: null,
        expiresAt: data.exp,
        impersonated: data.impersonated,
        impersonator: data.impersonator,
      };
      this.auth.logout().subscribe(() => {
        this.auth.setCredentials(credentials, true);
        this.auth.getUserInfo().subscribe();
        this.router.navigate(['/home'], { skipLocationChange: true, replaceUrl: true });
      });
    } else {
      this.router.navigate(['/404'], { skipLocationChange: true, replaceUrl: true });
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/impersonate.component.ts